import Title from 'Components/Atoms/Title/Title';
import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './FormSection.module.sass';

const FormSection = ({
    title, size,
    children
}: Props) => {
    return <div className={styles['formsection']}>
        { title &&
            <div className={styles['formsection__header']}>
                <Title weight='semibold' size={size || 'medium'}>{ title }</Title>
            </div>
        }
        { children }
    </div>;
}

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    title?: string
    size?: 'small' | 'medium'
}

export default FormSection;